import { motion } from 'framer-motion';
import React from 'react';
import CloseIcon from '@/public/icons/close.svg';
import styles from './CloseButton.module.scss';

// Props Types
// interface autoFocusTypes {
// 	focus: boolean;
// 	delay?: number;
// }

interface CloseButtonProps {
	onClick: () => void;
	classes?: {
		button?: string;
		icon?: string;
	};
}

// Animation
const closeButtonMotion = {
	initial: 'default',
	animate: 'default',
	whileTap: 'tap',
	whileHover: 'hover',
	whileFocus: 'focus',
	variants: {
		default: {
			scale: 1,
			rotate: 0,
		},
		hover: {
			scale: 1,
			rotate: '90deg',
		},
		focus: {
			scale: 1,
			rotate: '90deg',
		},
		tap: {
			scale: 0.8,
			rotate: '90deg',
		},
	},
	transition: {
		duration: 0.25,
	},
};

export const CloseButton: React.FC<CloseButtonProps> = ({
	onClick,
	classes,
}) => (
	<motion.button
		type='button'
		className={`${styles['button']} ${classes?.button ?? ''}`}
		onClick={onClick}
		// Animation
		{...closeButtonMotion}
	>
		<CloseIcon className={`${styles['button__icon']} ${classes?.icon ?? ''}`} />
	</motion.button>
);
